const config = {
  // 禁用所有message
  disableAllMessage: false,
}

export default config
